"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RBComTypeGroupSchemas = void 0;
const content_schema_1 = require("./reference/localized/type-groups/content.schema");
const content_schema_2 = require("./reference/type-groups/content.schema");
const attributes_schema_1 = require("./type-groups/attributes.schema");
const content_schema_3 = require("./type-groups/content.schema");
const master_schema_1 = require("./type-groups/master.schema");
const meta_schema_1 = require("./type-groups/meta.schema");
const audio_schema_1 = require("./type-groups/services/audio.schema");
const embeds_schema_1 = require("./type-groups/services/embeds.schema");
const forms_schema_1 = require("./type-groups/services/forms.schema");
const image_schema_1 = require("./type-groups/services/image.schema");
const links_schema_1 = require("./type-groups/services/links.schema");
const social_schema_1 = require("./type-groups/services/social.schema");
const live_schema_1 = require("./type-groups/services/video/live.schema");
const video_schema_1 = require("./type-groups/services/video.schema");
const services_schema_1 = require("./type-groups/services.schema");
exports.RBComTypeGroupSchemas = [
    content_schema_1.ContentLocalizedReferenceTypeGroupSchema,
    content_schema_2.ContentReferenceTypeGroupSchema,
    attributes_schema_1.AttributesTypeGroupSchema,
    content_schema_3.ContentTypeGroupSchema,
    master_schema_1.MasterTypeGroupSchema,
    meta_schema_1.MetaTypeGroupSchema,
    audio_schema_1.ServicesAudioTypeGroupSchema,
    embeds_schema_1.ServicesEmbedsTypeGroupSchema,
    forms_schema_1.ServicesFormsTypeGroupSchema,
    image_schema_1.ServicesImageTypeGroupSchema,
    links_schema_1.ServicesLinksTypeGroupSchema,
    social_schema_1.ServicesSocialTypeGroupSchema,
    live_schema_1.ServicesVideoLiveTypeGroupSchema,
    video_schema_1.ServicesVideoTypeGroupSchema,
    services_schema_1.ServicesTypeGroupSchema
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS1ncm91cC5zY2hlbWFzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21vZHVsZXMvdHlwZS1ncm91cC5zY2hlbWFzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHFGQUEyRztBQUMzRywyRUFBd0Y7QUFDeEYsdUVBQTJFO0FBQzNFLGlFQUFxRTtBQUNyRSwrREFBbUU7QUFDbkUsMkRBQStEO0FBQy9ELHNFQUFrRjtBQUNsRix3RUFBb0Y7QUFDcEYsc0VBQWtGO0FBQ2xGLHNFQUFrRjtBQUNsRixzRUFBa0Y7QUFDbEYsd0VBQW9GO0FBQ3BGLDBFQUEyRjtBQUMzRixzRUFBa0Y7QUFDbEYsbUVBQXVFO0FBRTFELFFBQUEscUJBQXFCLEdBQWM7SUFDOUMseURBQXdDO0lBQzFDLGdEQUErQjtJQUMvQiw2Q0FBeUI7SUFDekIsdUNBQXNCO0lBQ3RCLHFDQUFxQjtJQUNyQixpQ0FBbUI7SUFDbkIsMkNBQTRCO0lBQzVCLDZDQUE2QjtJQUM3QiwyQ0FBNEI7SUFDNUIsMkNBQTRCO0lBQzVCLDJDQUE0QjtJQUM1Qiw2Q0FBNkI7SUFDN0IsOENBQWdDO0lBQ2hDLDJDQUE0QjtJQUM1Qix5Q0FBdUI7Q0FDdEIsQ0FBQSJ9